import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import axios from "axios";
import "./App.css";

import Dashboard from "./views/Dashboard";
import ModsView from "./views/ModsView";
import StartupView from "./views/StartupView";
import LoginView from "./views/LoginView";
import ProfilesView from "./views/ProfilesView";
import "./views/DesktopLayout.css";

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [restartRequired, setRestartRequired] = useState(false);
  const [activeProfile, setActiveProfile] = useState(() => sessionStorage.getItem("activeProfile"));
  const [configRevision, setConfigRevision] = useState(0);
  const profileLoaded = (name, loaded = true) => {
    setActiveProfile(name);
    if (name) sessionStorage.setItem("activeProfile", name);
    else sessionStorage.removeItem("activeProfile");
    if (loaded) {
      setConfigRevision(value => value + 1);
      setRestartRequired(true);
    }
  };

  // On load → check sessionStorage
  useEffect(() => {
    const saved = sessionStorage.getItem("arma-auth");
    if (saved === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  // Auto-clear restart banner if server is running
  useEffect(() => {
    const interval = setInterval(() => {
      axios.get("/api/server/status")
        .then(res => {
          if (res.data.status === "active") {
            setRestartRequired(false);
          }
        })
        .catch(() => {});
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = () => {
    sessionStorage.setItem("arma-auth", "true");
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("arma-auth");
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <LoginView onLogin={handleLogin} />;
  }

  return (
    <Router>
      <div className="app-shell">

        {/* Sidebar */}
        <aside className="sidebar">
          <div className="brand">
            <span className="brand-mark" aria-hidden="true">A</span>
            <div><h2>Arma Manager</h2><span>REFORGER / CONTROL PANEL</span></div>
          </div>
          <p className="nav-label">WORKSPACE</p>
          <nav aria-label="Main navigation">
            <NavLink to="/" end>Dashboard</NavLink>
            <NavLink to="/mods">Mods</NavLink>
            <NavLink to="/startup">Startup</NavLink>
            <NavLink to="/profiles">Profiles</NavLink>
          </nav>
          <div className="sidebar-footer">
            <span className="sidebar-caption">Arma Reforger</span>
            <button className="button-secondary" onClick={handleLogout}>Logout</button>
          </div>
        </aside>

        {/* Main Content */}
        <main className="main-content">

          {/* Restart Required Banner */}
          {restartRequired && (
            <div className="restart-banner" role="status">
              Restart Required – Changes will not take effect until the server is restarted.
            </div>
          )}

          <div className="page-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/mods" element={<ModsView key={configRevision} setRestartRequired={setRestartRequired} />} />
              <Route path="/profiles" element={<ProfilesView activeProfile={activeProfile} onProfileLoaded={profileLoaded} />} />
              <Route path="/startup" element={<StartupView key={configRevision} setRestartRequired={setRestartRequired} />} />
            </Routes>
          </div>

        </main>

      </div>
    </Router>
  );
}

export default App;
